/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 30 2024
 **/

import { ComponentType, useState } from "react";

import { GridContentStyle } from "./emotion";

type GridContentsProps = {
	contents: string[];
	onClick: (e: HtmlMouseEvent) => void;
	Component: ComponentType<{ src: string }>;
};

export default function GridContent({ contents, onClick, Component }: GridContentsProps) {
	const [selectedIndex, setSelectedIndex] = useState<number>(0);

	const handleClick = (e: HtmlMouseEvent) => {
		const index = e.currentTarget.getAttribute("data-index") as number;
		setSelectedIndex(index);
		onClick(index);
	};

	return (
		<>
			{contents.map((src, index) => (
				<div
					css={GridContentStyle}
					className={selectedIndex == index ? "show" : ""}
					data-index={index}
					onClick={handleClick}
				>
					<Component src={src} />
				</div>
			))}
		</>
	);
}
